import React, { Component } from 'react';
import resizeEvent from 'element-resize-event';
import Portal from "./Portal";

class Popup extends Component {
  constructor(props) {
    super(props);
    this.state= {
      showed: false,
    };
    this._onWindowResize=()=>{
      this.centerPopup();
    }
  }
  centerPopup() {
    if(this._popupWin) {
      const rect=this._popupWin.getBoundingClientRect();
      this._popupWin.style.left=(window.innerWidth-rect.width)/2+'px';
      this._popupWin.style.top=(window.innerHeight-rect.height)/2+'px';
    }
  }
  componentWillUpdate() {

  }
  componentDidMount() {
    //this.centerPopup();
    this.componentDidUpdate();
  }
  componentWillMount() {
    this.setState({
      showed:this.props.showed
    });
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      showed:nextProps.showed
    });
  }
  componentWillUnmount() {
    window.removeEventListener("resize",this._onWindowResize);
    if(this._popupWin) {
      resizeEvent.unbind(this._popupWin);
    }
    if(this.props.onHide) {
      this.props.onHide();
    }
  }
  componentDidUpdate() {
    if(this.state.showed) {
      window.addEventListener("resize",this._onWindowResize);
      resizeEvent(this._popupWin,()=>{ this.centerPopup() });
    } else {
      window.removeEventListener("resize",this._onWindowResize);
      if(this.props.onHide) {
        this.props.onHide();
      }
    }
    this.centerPopup();
  }
  render() {
    if(!this.state.showed) {
      return null;
    }

    return (
      <Portal>
        <div>
          {!this.props.disable_overlay?(
            <div className="pf w100 h100 bg-w5-op20 pa-tl" style={{zIndex:21000}} onClick={()=>{
              resizeEvent.unbind(this._popupWin);
              this.setState({ showed: false });
            }}></div>
          ):null}
          <div ref={(ref)=>{ this._popupWin=ref; }} className={`pf rad4 ${this.props.only_children?'':`${this.props.disableScroll?'':'ofa'} ${this.props.bg_class || "bg-w1"}`}`} style={{zIndex:21001, maxHeight:'100vh', maxWidth:'100vw'}}>
            {this.props.only_children?this.props.children:(
              <div className="pr">
                {this.props.title && (
                  <div className={`${this.props.titleClassName} hpadd20 vpadd5`}>{this.props.title}</div>
                )}

                <div className={`${this.props.disablePaddings?'':'padd20'}`}>
                  {this.props.children}
                </div>
                <div className={`padd20 ${this.props.leftButtons || this.props.rightButtons?'':'dn'}`}>
                  <div className="fl">
                    {this.props.leftButtons}
                  </div>
                  <div className="fr">
                    {this.props.rightButtons}
                  </div>
                  <div className="cb"></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Portal>
    )
  }
}

export default Popup;